"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "isola-d-asti": {
    "abaa5f05": [{
      "hkey": "88c70af2",
      "slug": "piano-molini-d-isola",
      "name": "Piano-Molini d'Isola",
      "primary": true,
      "skipSearch": false
    }],
    "molini": [{
      "hkey": "88c70af2",
      "slug": "piano-molini-d-isola",
      "name": "Piano-Molini d'Isola",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "isola-d-asti"
    }],
    "3bb29abf": [{
      "hkey": "88c70af2",
      "slug": "piano-molini-d-isola",
      "name": "Piano-Molini d'Isola",
      "primary": true,
      "skipSearch": false
    }],
    "piano": [{
      "hkey": "88c70af2",
      "slug": "piano-molini-d-isola",
      "name": "Piano-Molini d'Isola",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "isola-d-asti"
    }]
  }
};
exports["default"] = _default;